module.exports = __webpack_public_path__ + "img/36.b3c1d32e.png";